import {
  RelocationPlanDetails
} from "./RelocationPlanDetails";

function RelocationDetailsViewModel() {
  return {

    RelocationPlanDetails: RelocationPlanDetails,
    RelocationPlanDependant: RelocationPlanDependant,
    DeptItems :[],
    GeneralDetails :[],

    genericField: null,
    GenderTypeID: 0,
    SelectSpouse : true,
    SelectedTitle: 0,
    SelectedOldSpouseTitle: 0,
    SelectedNewSpouseTitle: 0,
    // public List<SelectListItem> TitleList { get; set; }
    // public List<SelectListItem> STitleList { get; set; }

    // public List<SelectListItem> SRankList { get; set; }
    // public List<SelectListItem> DTitleList { get; set; }

    SelectedReason: null,
    // public List<SelectListItem> ReasonList { get; set; }

    SelectedStatus: 0,
    // public List<SelectListItem> StatusList { get; set; }

    SelectedCircumstance: null,
    // public List<SelectListItem> CircumstanceList { get; set; }

    SelectedPosting: null,
    // public List<SelectListItem> PostingList { get; set; }

    pSelectedUnitLocation: 0,
    // public List<SelectListItem> UnitList { get; set; }
    // public List<SelectListItem> AdminUnitList { get; set; }
    SelectedBaseLocation: 0,

    // public List<SelectListItem> LocationList { get; set; }

    SelectedTenure: 0,
    // public List<SelectListItem> TenureList { get; set; }

    SelectedRelation: 0,
    // public List<SelectListItem> RelationList { get; set; }

    SelectedService: 0,
    // public List<SelectListItem> ServiceList { get; set; }
    SelectedStayLocation: 0,
    // public List<SelectListItem> StayLocationList { get; set; }

    // public List<SelectListItem> PriorStateList { get; set; }
    // public List<SelectListItem> PostStateList { get; set; }
    // public List<SelectListItem> DepStateList { get; set; }


    // public List<SelectListItem> CountryList { get; set; }

    SelectedPriorCountry: null,
    SelectedPostCountry: null,
    SelectedDepCountry: null,

    PriorStateFlag: false,
    PostStateFlag: false,
    DepStateFlag: false,

    SelectedSpouseDepartment: null,
    // public List<SelectListItem> DepartmentList { get; set; }

    SelectedSchoolType: 0,
    // public List<SelectListItem> SchoolTypeList { get; set; }

    // public List<SelectListItem> PositionDescriptionList { get; set; }

    // public List<CategoryDocuments> CategoryDocuments { get; set; }
    DocumentCount: 0,

  }
}

function RelocationPlanDependant() {
  return {
    RelocationPlanID: 0,
    CaseID: 0,
    DefenceCategorisationID: 0,
    CategorisationRecognisedDate: null,
    CategorisationLocationName: null,
    IsTravellingWithPartner: false,
    IsTravellingWithDependents: false,
    AreDependentsCurrentLocation: false,
    DependentOtherAddressID: 0,
    ConcurrencyCheck: [],
    OrderSubTypeID: 0,
    DependantsCount: 0,
    RelocationDependents: [],
    RelocationSpouse: RelocationDependents,
    DependentStreetAddress: {
      AddressID: 0,
      StreetAddressAddressID: 0,
      AddressSubTypeID: 0,
      ConcurrencyCheck: [],
      StreetAddressLine1: "",
      StreetAddressLine2: "",
      StreetAddressLine3: null,
      StreetAddressConcurrencyCheck: [],
      IsPrimaryContact: false,
      StreetAddressPostCode: "",
      StreetAddressCity: "",
      StreetAddressState: "",
      StreetAddressCountry: "Australia",
      StreetAddressLatitude: 0,
      StreetAddressLongitude: 0,
      IsValidated: true,
      StreetAddressSubTypeID: 0,
      CurrentState: 0

  },
    CurrentState: 0,
  }

}

function RelocationDependents() {
  return {
    RelocationPlanDependentID: 0,
    RelocationPlanID: 0,
    FamilyMemberPartyID: 0,
    RankLosingLocationID: null,
    RankLosingLocationDesc: null,
    RankGainingLocationID: null,
    RankGainingLocationDesc: null,
    GainingSchoolTypeID: 0,
    RelationshipOther: null,
    ConcurrencyCheck: [],
    OrderSubTypeID: 0,
    Dependant: DependantData,
    CurrentState: 0,

  }
}

function DependantData() {
  return {
    PartyID: 0,
    IndividualPartyId: 0,
    GivenName: null,
    MiddleName: null,
    FamilyName: null,
    TitleID: null,
    TitleDesc: null,
    PreferredName: null,
    DateOfBirth: null,
    IsClientTypeAsDefence: true,
    PartyStatusID: 0,
    GenderTypeID: 0,
    GenderTypeDesc: null,
    PartyRelatedRoleID: 0,
    PartyRelatedRoleDesc: null,
    PartyRelatedPartyID: 0,
    ADFRecognised: false,
    ADFRecognisedDate: null,
    ADFRecognisedLocation: null,
    IsEmployeeNumberReminder: false,
    PreferredContactMethodTypeID: 0,
    RelationshipOther: null,
    ConcurrencyCheck: null,
    PartyConcurrencyCheck: null,
    PartyRelatedConcurrencyCheck: null,
    FamilyMemberConcurrencyCheck: null,
    ADFAPSEmployee: false,
    DepartmentID: 0,
    ClientOrganisationPartyDesc: null,
    ClientOrganisationPartyID: 0,
    EmployeeNumber: null,
    ServiceNumber: null,
    ADFReserve: null,
    ForeignDefenceExchangePersonnel: null,
    IsDeleted: false,
    PartySubTypeID: 0,
    IndividualSubTypeID: 0,
    TypeID: 0,
    CurrentState: 0,
    NewSchool: false,
    FamilyMemberPartyID: 0,
    RelocationPlanDependentID: 0
  }
}

export {
  DependantData,
  RelocationDependents,
  RelocationPlanDependant,
  RelocationDetailsViewModel
}

